import { IconButton, Stack, Typography } from "@mui/material"
import EditableText from "components/controls/input-hidden"
import ArrowBackIcon from "components/icons/base/back"
import SaveIcon from "components/icons/editor/save"
import { action } from "mobx"
import { observer } from "mobx-react-lite"
import blockTypes from "pages/scheme-editor/block-types"
import { useSchemeEditorStore } from "pages/scheme-editor/store"
import { useMainStore } from "store"
import useKeyDown from "utils/use-key-down"
import { useLocation } from "wouter"
import { 
  MenuBlockContainer, 
  MenuBlockContent, 
  MenuBlockHeader, 
  MenuBlockItem, 
  MenuBlockItemSubTitle, 
  MenuBlockItemTitle 
} from "./styled"

const MenuBlocks = observer(() => {

  const mainStore = useMainStore()
  const [ , setLocation ] = useLocation()
  const schemeStore = useSchemeEditorStore()

  useKeyDown({
    "KeyS": (e) => { if (e.ctrlKey) {
        save()
        e.preventDefault()
    }}
  })

  const save = () => {
    schemeStore.save(mainStore)
  }

  const goToBack = () => {
    setLocation("/")
  }

  return (
    <MenuBlockContainer onMouseLeave={schemeStore.create.onMenuMouseLeave}>
      <MenuBlockHeader>
        <IconButton onClick={goToBack} sx={{ ml: -1.5, mr: 0.2, color: "text.secondary" }}>
          <ArrowBackIcon/>
        </IconButton>
        <Stack mr={0.5} overflow="hidden">
          <EditableText 
            sx={{ fontSize: 14, fontWeight: 700,  }} 
            placeholder="Название схемы"
            value={schemeStore.name}
            onChange={action(e => schemeStore.name = e.target.value)}
          />
          <EditableText
            sx={{ fontSize: 11, fontWeight: 600, mt: -0.5, color: "text.secondary" }}
            placeholder="ID схемы"
            value={schemeStore.schemeSlug}
            onChange={action(e => {
              schemeStore.slug = e.target.value !== schemeStore.nameAsSlug? e.target.value: null
            })}
          />
        </Stack>
        {schemeStore.isSaved === false && (
          <IconButton color="primary" onClick={save} sx={{ ml: "auto", mr: -0.5, bgcolor: "background.default" }}>
            <SaveIcon sx={{ fontSize: 19 }} />
          </IconButton>
        )}
      </MenuBlockHeader>
      <MenuBlockContent>
        <Typography sx={{ px: 2, fontSize: 9, color: "primary.dark", fontWeight: 600 }}>
          Доступные блоки
        </Typography>
        { Object.entries(blockTypes).map(([ key, value ]) => (
          <MenuBlockItem key={key} onMouseDown={(e) => schemeStore.create.onMenuItemMouseDown(e, key as any)}>
            <MenuBlockItemTitle>{ value.title }</MenuBlockItemTitle>
            <MenuBlockItemSubTitle>{ value.description || "" }</MenuBlockItemSubTitle>
          </MenuBlockItem>
        ))}
      </MenuBlockContent>
    </MenuBlockContainer>
  )
})

export default MenuBlocks